import {TOKEN_KEY, DEV, VERIFY_TIME_KEY, VERIFY_TIME, CHANGE_MOBILE_VERIFY_TIME_KEY} from '@/config'
import store from '@/store'
import {BASE_URL, DEV_BASE_URL} from '@/api'
import dayjs from 'dayjs'

/**
 * 获取token
 */
export function getToken() {
    // if ( DEV ) {
    //     return 'b9c5a5314cbb67540116139b20a4f635e06feab5'
    // }
    return localStorage.getItem(TOKEN_KEY)
}

/**
 * 设置token
 */
export function setToken(val) {
    localStorage.setItem(TOKEN_KEY, val)
}

/**
 * 获取地址
 */
export function getBaseUrl() {
    if (DEV) {
        return DEV_BASE_URL
    }
    return BASE_URL
}

/**
 *  比较版本
 * @param curV 本地版本
 * @param reqV 线上版本
 * @returns {boolean}
 */
export function versionCheck(curV, reqV) {
    let arr1 = curV.split('.');
    let arr2 = reqV.split('.');
    //将两个版本号拆成数字
    let minL = Math.min(arr1.length, arr2.length);
    let pos = 0;        //当前比较位
    let diff = 0;        //当前为位比较是否相等

    //逐个比较如果当前位相等则继续比较下一位
    while (pos < minL) {
        diff = parseInt(arr1[pos]) - parseInt(arr2[pos]);
        if (diff != 0) {
            break;
        }
        pos++;
    }
    if (diff < 0) { //新版本
        return true
    } else {
        return false
    }
}

/*
存储验证码发送时间
 */
export function setSendVerifyTime(key) {
    localStorage.setItem(key, dayjs().unix().toString())
}

/**
 * 获取验证码还要多久才能发送
 * @returns {boolean 或 还需要的秒数}
 */
export function getVerifyTimeLeft(key) {
    let preTime = localStorage.getItem(key)
    if (!preTime) {
        return false
    }
    let timeDiff = dayjs().unix() - preTime
    if (timeDiff >= VERIFY_TIME) {
        return false
    }
    return VERIFY_TIME - timeDiff
}

/*
根据屏幕宽度计算大小
 */
export function calcSize(size) {
    let bodyWidth = window.document.body.offsetHeight
    let baseWidth = 667
    return parseInt((size / baseWidth) * bodyWidth)
}
